import { Component, OnInit, Inject, Injectable } from '@angular/core';
import { Router, ActivatedRoute, Params } from "@angular/router";

import { ClientService } from '../../services/client.service';
import { MessageService } from '../../services/message.service';
import { AuthService } from '../../services/auth.service';
import { FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { ClientStyleService } from 'src/app/services/client-style.service';
import { BaseComponent } from '../base/base.component';

@Component({
	selector: 'home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})
export class HomeComponent extends BaseComponent implements OnInit {
	
    constructor(
        @Inject(DOCUMENT) private document: Document,
        public router: Router, 
        public activatedRoute: ActivatedRoute, 
        private _clientService: ClientService, 
        private _messageService: MessageService, 
        private _authService: AuthService,
        private _clientStyleService: ClientStyleService
    ){
        super(router, activatedRoute, _messageService, _clientService, _clientStyleService)
    }
	
	ngOnInit(): void {
        super.ngOnInit();
	}

	
}
